import { render, staticRenderFns } from "./UsuariosEditar.vue?vue&type=template&id=52bb419b&scoped=true&dark=true"
import script from "./UsuariosEditar.vue?vue&type=script&lang=js"
export * from "./UsuariosEditar.vue?vue&type=script&lang=js"
import style0 from "./UsuariosEditar.vue?vue&type=style&index=0&id=52bb419b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb419b",
  null
  
)

export default component.exports